import { buildScopedI18n } from '../../../../../utils/buildScopedI18n';
import configNotariesEsCL from './locales/es-CL.json';
import configNotariesEnUS from './locales/en-US.json';
import configNotariesPtBR from './locales/pt-BR.json';

export const configNotariesI18n = buildScopedI18n({
  esCL: configNotariesEsCL,
  enUS: configNotariesEnUS,
  ptBR: configNotariesPtBR,
});
